module.exports = __webpack_public_path__ + "img/icon-giveaway.b3fde405.png";